import {
  collection,
  doc,
  limit,
  onSnapshot,
  query,
  updateDoc,
  where,
  writeBatch,
} from 'firebase/firestore';
import { db } from '../firebase';

const notificationTime = (notification) => {
  const value = notification?.createdAt;
  if (value?.toDate) return value.toDate().getTime();
  const timestamp = new Date(String(value || '')).getTime();
  return Number.isFinite(timestamp) ? timestamp : 0;
};

export function isNotificationPermissionError(error) {
  return error?.code === 'permission-denied'
    || error?.code === 'firestore/permission-denied';
}

export function subscribeNotifications(userId, recipientRole, callback, onError) {
  if (!userId || !recipientRole) {
    callback([]);
    return () => {};
  }

  return onSnapshot(
    query(
      collection(db, 'notifications'),
      where('recipientId', '==', userId),
      where('recipientRole', '==', recipientRole),
      limit(30),
    ),
    (snapshot) => {
      const notifications = snapshot.docs
        .map((notificationDoc) => ({
          id: notificationDoc.id,
          ...notificationDoc.data(),
        }))
        .sort((a, b) => notificationTime(b) - notificationTime(a));
      callback(notifications);
    },
    (error) => {
      onError?.(error);
      callback([]);
    },
  );
}

export async function markNotificationRead(notificationId) {
  if (!notificationId) return;
  await updateDoc(doc(db, 'notifications', notificationId), {
    read: true,
    readAt: new Date().toISOString(),
  });
}

export async function markAllNotificationsRead(notifications) {
  const unread = notifications.filter((notification) => !notification.read);
  if (unread.length === 0) return;

  const batch = writeBatch(db);
  const readAt = new Date().toISOString();
  unread.forEach((notification) => {
    batch.update(doc(db, 'notifications', notification.id), {
      read: true,
      readAt,
    });
  });
  await batch.commit();
}

export function formatNotificationTime(notification) {
  const timestamp = notificationTime(notification);
  if (!timestamp) return '';

  return new Intl.DateTimeFormat('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(timestamp));
}
